( function () {
	'use strict';

	function middleEllipsis () {
		function returnAsIs ( text ) {
			return text;
		}

		function truncate ( text, len ) {
			var separator = '...';

			var maxLength  = len - separator.length;
			var showLength = parseInt( maxLength / 2 );

			return text.substr( 0, showLength ) + separator + text.substr( text.length - showLength );
		}

		return function ( text, len ) {
			return ( text && text.length > len && truncate || returnAsIs )( text, len );
		};
	}

	angular.module( 'app.components' )
		.filter( 'middleEllipsis', middleEllipsis );
} )();
